var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-lottie"},[_c('div',{ref:"lavContainer",staticClass:"g-lottie__img"})])}
var staticRenderFns = []

export { render, staticRenderFns }